export const REACT_APP_SPOTIFY_SCOPES = "playlist-read-private,playlist-read-collaborative,user-read-email,playlist-modify-private"